module.exports = __webpack_public_path__ + "static/media/slide_01.6a3ba627.jpg";